import { render, staticRenderFns } from "./ThePage.vue?vue&type=template&id=f9eb2130&scoped=true&"
import script from "./ThePage.vue?vue&type=script&lang=js&"
export * from "./ThePage.vue?vue&type=script&lang=js&"
import style0 from "./ThePage.vue?vue&type=style&index=0&id=f9eb2130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9eb2130",
  null
  
)

export default component.exports